/*
 references api
*/

import axios from '../axios/axios';

export function getReferencesApi(params) {
  return axios.post('/users/getreferences', params);
}

export function getFullReferencesApi(params) {
  return axios.post('/users/getfullreferences', params);
}

export function getReferenceAddItemApi(params) {
  return axios.post('/users/referenceadditem', params);
}

export function getReferenceRemoveItemApi(params) {
  return axios.post('/users/referenceremoveitem', params);
}
export function getReferenceRemoveItemFromApiApi(params) {
  return axios.post('/users/referenceRemoveItemFromApi', params);
}

export function getReferenceUpdateItemApi(params) {
  return axios.post('/users/referenceUpdateItem', params);
}

export function getThematicListApi(params) {
  return axios.post('/thematics/getThematicList', params);
}

export function getAddThematicApi(params) {
  return axios.post('/thematics/addThematic', params);
}

export function getRemoveThematicApi(params) {
  return axios.post('/thematics/closeThematic', params);
}

export function getThematicKeywordsApi(params) {
  return axios.post('/thematics/getThematicKeywords', params);
}

export function getUpdateThematicApi(params) {
  return axios.post('/thematics/updateThematic', params);
}

export function getAddThematicKeywordApi(params) {
  return axios.post('/thematics/addThematicKeyword', params);
}

export function getRemoveThematicKeywordApi(params) {
  return axios.post('/thematics/removeThematicKeyword', params);
}

export function getReferenceGetItemKeywordsApi(params) {
  return axios.post('/users/referenceGetItemKeywords', params);
}

export function getReferenceAddItemKeywordApi(params) {
  return axios.post('/users/referenceAddItemKeyword', params);
}

export function getReferenceRemoveItemKeywordApi(params) {
  return axios.post('/users/referenceRemoveItemKeyword', params);
}

export function getReferenceAddItemUsersApi(params) {
  return axios.post('/users/linkReferenceItemToUser', params);
}

export function getReferenceAddItemExtUsersApi(params) {
  return axios.post('/users/linkReferenceItemToExtUser', params);
}

export function getReferencesApiListApi() {
  return axios.post('/references/getApiList');
}

export function getReferenceRemoveItemUsersApi(params) {
  return axios.post('/users/unlinkReferenceItemFromUser', params);
}

export function getReferenceRemoveItemExtUsersApi(params) {
  return axios.post('/users/unlinkReferenceItemFromExtUser', params);
}
